<template>
  <b-list-group-item :key="contract.id" @click="contractClick(contract.id)" href="#" :class="[(contract.livemonitor.inputStatus & 0x01) == 0x01 ? 'list-group-item-accent-success' : 'list-group-item-accent-danger', 'list-group-item-divider']">
    <div class="float-right">
      <img :src="'img/map/' + contract.color + '/' + contract.vehicleType + '.png'">
    </div>
    <div :style="{textDecoration: selectedContract && selectedContract.id === contract.id ? 'underline' : 'none'}"><strong>{{ contract.alias }}</strong>
    </div>
    <small class="text-muted mr-3">
      <i class="icon-calendar"></i>&nbsp;&nbsp;{{ contract.livemonitor.lastFixAt | formatDate }}
    </small><br/>
    <small class="text-muted">
      <i class="icon-location-pin"></i>&nbsp;&nbsp;<AddressGeocoder v-if="isFleetExpanded(contract.fleetId)" :latitude="contract.livemonitor.latitude" :longitude="contract.livemonitor.longitude" />
    </small>
  </b-list-group-item>
</template>

<script>
import { mapGetters } from 'vuex'
import AddressGeocoder from '@/components/AddressGeocoder.vue';
import {
  SELECT_SINGLE_CONTRACT,
} from '@/store/mutation-types';

export default {
  name: 'vehicle',
  props: ['contract'],
  components: {
    AddressGeocoder
  },
  methods: {
    contractClick: function(contractId) {
      this.$store.commit(SELECT_SINGLE_CONTRACT, contractId);
    },
  },
  computed: {
    ...mapGetters([
        'selectedContract',
        'isFleetExpanded',
      ]),
  }
}
</script>

<style scoped>
</style>
